import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ToggleSwitch from "../components/ToggleSwitch";
import { useTranslation } from "react-i18next";
import { useBuilding } from "../context/buildingContext";
import { fetchApi } from "../utils/fetchApi";
import { useUser } from "../context/userContext";
import { useRooms } from "../context/RoomsContext";
import { PasswordChange } from '../components/PasswordChange';

const Settings: React.FC = () => {
  const { t } = useTranslation();
  const { buildingId, apartmentId } = useBuilding();
  const { rooms, setRooms } = useRooms();
  const navigate = useNavigate();
  const { logout } = useUser();

  const [isChildLockEnabled, setChildLockEnabled] = useState<boolean | null>(null);
  const [childLockError, setChildLockError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (rooms.length > 0) {

      // Ellenőrizzük, hogy az összes szobában azonos-e a `childLock` érték
      const uniqueChildLocks = new Set(rooms.map((room) => room.childLock));
      console.log(rooms, uniqueChildLocks);
      if (uniqueChildLocks.size === 1) {
        // Csak akkor állítjuk be az értéket, ha még nincs felhasználói módosítás
        setChildLockEnabled((prev) => (prev === null ? rooms[0].childLock : prev));
        setChildLockError(null);
      } else {
        setChildLockError(t("error.inconsistentChildLock"));
      }
    }
    setLoading(false);
  }, [rooms, t, setRooms]);

  const toggleChildLock = () => {
    setChildLockEnabled((prev) => !prev);
  };

  const saveSettings = async () => {
    if (!buildingId || !apartmentId || isChildLockEnabled === null) return;

    try {
      // Minden szoba termosztátjára API-hívást küldünk a frissített `child_lock` értékkel
      await Promise.all(
        rooms.map(async (room) => {
          await fetchApi("update_thermostat_settings", {
            thermostat_id: room.thermostatId,
            child_lock: isChildLockEnabled,
          });
        })
      );

      // Frissítjük a `RoomsContext`-et az új `childLock` értékekkel
      setRooms(
        rooms.map((room) => ({
          ...room,
          childLock: isChildLockEnabled,
        }))
      );

      alert(t("settingsSaved"));
    } catch (err) {
      console.error("Error saving settings:", err);
      alert(t("error.savingFailed"));
    }
  };

  const backToBuildingSelector = () => {
    navigate("/");
  };

  return (
    <div className="timetable">
      {(error || childLockError) ? (
        <p className="error">{error}{childLockError}</p>
      ) : loading ? (
        <p>{t("loading")}</p>
      ) : (
        <>
              {rooms.length > 0 && (
                <>
                  <ToggleSwitch
                    label={t('childLock')}
                    isChecked={isChildLockEnabled ?? false} // Ha még nincs beállítva, alapértelmezett false
                    onToggle={toggleChildLock}
                  />
                  <button className="button" onClick={saveSettings} disabled={!!childLockError}>
                    {t('save')}
                  </button>
                </>
              )}
          <hr />
          <PasswordChange />
          <hr />
        </>
      )}
      <button className="button changeApartmentButton" onClick={backToBuildingSelector}>
        {t('chooseApartmentTitle')}
      </button>
      <hr />
      <button className="logoutButton" onClick={logout}>
        {t('logOut')}
      </button>
    </div>
  );
};

export default Settings;
